import { SocketData } from 'actions/socket/socketReceiveDataAction'
import { prepareMessagesStructure } from 'components/page/Chat/Messenger/Messenger.functions'
import { ChatMessengerState } from 'reducers/messenger/ChatMessengerState'
import { markAllMessagesAsReaded } from 'reducers/messenger/messenger.functions'

export const markMessagesAsReaded = (
  readerMessages: SocketData<{ anketaId: number }>,
  chatState: ChatMessengerState
): ChatMessengerState => {
  const content = readerMessages.content

  if (Number(content.anketaId) === chatState.selectedProfileId) {
    if (chatState.loadingChat) {
      return {
        ...chatState,
        deferredMarkAllReaded: true,
      }
    } else {
      const updatedMessages = markAllMessagesAsReaded([...chatState.messages])

      return {
        ...chatState,
        messages: updatedMessages,
        messagesByDays: prepareMessagesStructure(updatedMessages),
      }
    }
  }

  return chatState
}
